import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import APAlfredLogo from './APAlfredLogo';
import ThemeSwitcher from './ThemeSwitcher';

const { FiMenu } = FiIcons;

function Header({ onMenuClick }) {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-30 dark:bg-gray-800 dark:border-gray-700">
      <div className="flex items-center justify-between px-4 py-3 max-w-7xl mx-auto">
        <div className="flex items-center">
          <motion.button 
            onClick={onMenuClick}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors dark:hover:bg-gray-700"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            aria-label="Toggle sidebar menu"
          >
            <SafeIcon icon={FiMenu} className="w-6 h-6 text-gray-600 dark:text-gray-400" />
          </motion.button>
          <Link to="/" className="flex items-center ml-2 group">
            <motion.div 
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.3 }}
              className="mr-2"
            >
              <APAlfredLogo size={36} />
            </motion.div>
            <motion.h1 
              className="text-xl font-bold flex" 
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: 0.1 }}
              style={{ fontFamily: "'Poppins', sans-serif", fontWeight: '800' }}
            >
              <motion.span 
                className="text-[#2B5596] group-hover:scale-105 transition-transform" 
                whileHover={{ y: -2 }}
              >
                APA
              </motion.span>
              <motion.span 
                className="text-[#F54CC8] group-hover:scale-105 transition-transform" 
                whileHover={{ y: 2 }}
              >
                lfred
              </motion.span>
            </motion.h1>
          </Link>
        </div>
        <div className="flex items-center">
          <ThemeSwitcher />
        </div>
      </div>
    </header>
  );
}

export default Header;